import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { QuoteToolLiteStore } from '../store';

@Injectable({ providedIn: 'root' })
export class QTLiteStoreSignalsAdapterService {
  private readonly store = inject(QuoteToolLiteStore);

  readonly currentStepId = toSignal(this.store.currentStepId$);
  readonly currentStep = toSignal(this.store.currentStep$);
  readonly activeFlow = toSignal(this.store.activeFlow$);
  readonly selectedLanguage = toSignal(this.store.selectedLanguage$);
  readonly selectedSchoolLocation = toSignal(this.store.selectedSchoolLocation$);
  readonly selectedCourse = toSignal(this.store.selectedCourse$);
  readonly productPackage = toSignal(this.store.productPackage$);
  readonly selectedDuration = toSignal(this.store.selectedDuration$);
  readonly selectedAccommodation = toSignal(this.store.selectedAccommodation$);
  readonly selectedCurrency = toSignal(this.store.selectedCurrency$);
  readonly selectedTransferRows = toSignal(this.store.selectedTransferRows$);
  readonly studentDetails = toSignal(this.store.studentDetails$);
  readonly selectedPremiumActivities = toSignal(this.store.selectedPremiumActivities$);
  readonly upselling = toSignal(this.store.upselling$);
  readonly studentFirstName = toSignal(this.store.studentFirstName$);
  readonly selectedPremiumAccommodation = toSignal(this.store.selectedPremiumAccommodation$);
  readonly selectedStartDate = toSignal(this.store.selectedStartDate$);
  readonly selectedEndDate = toSignal(this.store.selectedEndDate$);
  readonly requestedQuotes = toSignal(this.store.requestedQuotes$);
}
